import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useGetOrderDetailsId from "../../../store/selectors/get-order-details";
import { updateHealthEntry } from "../../../utils/backend";
import useGetToken from "../../../store/selectors/get-token";
import { useTranslation } from 'react-i18next';

const DeclarationOne = () => {
	const { t } = useTranslation();
	const [agreement, setAgreement] = useState(false);
	const navigate = useNavigate();
	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);
	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const token = useGetToken();
	const getOrderDetails = useGetOrderDetailsId();

	const onAgreementChange = (e) => {
		setAgreement(e.checked);
		localStorage.setItem("declarationOne", JSON.stringify(e.checked));
	};

	useEffect(() => {
		const cachedAgreement = localStorage.getItem("declarationOne");

		if (cachedAgreement) setAgreement(JSON.parse(cachedAgreement));
		
	}, []);

	const submitSelectedPlan = async (e) => {
		e.preventDefault();
		
		if (!agreement) {
			showErrorMessage(`${t("messages.haveToAgreeTerms")}`);
			return;
		}

		const payload = {
			health_id: getOrderDetails.productId,
			health_data: {
				agree_life_declaration_1: agreement
			}
		};
		
		try {
			const response = await updateHealthEntry(token, payload);
			
			if (response.success) {
				navigate(`/get-health-quotes/nomination`);
			} else {
				showErrorMessage(`${t("common.error")}.` + response.message);
				return;
			}
		} catch (error) {
			showErrorMessage(`${t("messages.errorWhileSubmittingDetails")}`);
			return;
		}
	};

	return (
		<>
			<div className="content px-2">
				<div className="get-quote-process-container vw-50">
					<div className="d-flex w-100">
						<div className="d-flex flex-column">
							<h3 className="mb-0">{`${t("healthInsurance.declarationOne.title")}`}</h3>
							<div className="d-flex flex-row align-items-center vw-100">
								<span className="color-heading fw-bold my-2">
									{`${t("healthInsurance.declarationOne.subTitle")}`}
								</span>
							</div>

							<ol className="px-4">
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.1")}`}</li>
								<li className="text-justify color-heading my-4">
									{`${t("healthInsurance.declarationOne.points.2.title")}`}
									<ul>
										<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.2.1")}`}</li>
										<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.2.2")}`}</li>
										<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.2.3")}`}</li>
									</ul>
								</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.3")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.4")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.5")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.6")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.7")}`}</li>
								<li className="fw-bold text-justify color-primary my-4">{`${t("healthInsurance.declarationOne.points.8")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationOne.points.9")}`}</li>
							</ol>

							<div className="mb-4">
								<div className="flex">
									<Checkbox
										inputId="agreement"
										name="agreement"
										value={agreement}
										onChange={onAgreementChange}
										checked={agreement}
									/>
									<label htmlFor="agreement" className="ml-2">
										{`${t("healthInsurance.declarationOne.agreement")}`}
									</label>
								</div>
							</div>
						</div>
						<Button
							label={`${t("common.proceed")} (4/7)`}
							className="btn-primary"
							onClick={(e) => submitSelectedPlan(e)}
						/>

						{/* BottomMessagePopUp Component */}
						<BottomMessagePopUp
							message={errorMessage}
							type="error"
							isVisible={isErrorVisible}
							onClose={() => setIsErrorVisible(false)}
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default DeclarationOne;
